import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion, useScroll } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";

const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Drivers = lazy(() => import("./pages/Drivers"));
const Contact = lazy(() => import("./pages/Contact"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Terms = lazy(() => import("./pages/Terms"));

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

const ScrollProgress = () => {
    const { scrollYProgress } = useScroll();
    return (
        <motion.div
            data-testid="scroll-progress-bar"
            aria-hidden="true"
            className="fixed inset-x-0 top-0 z-[70] h-[3px] origin-left bg-brand"
            style={{ scaleX: scrollYProgress }}
        />
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <ScrollProgress />
                <Navbar />
                <main>
                    <Suspense fallback={<div className="min-h-screen bg-night" data-testid="page-loading" />}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/drivers" element={<Drivers />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/privacy" element={<PrivacyPolicy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </Suspense>
                </main>
                <Footer />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
